export const createSchema = {
  type: 'object',
  properties: {
    partnerType: {
      type: 'string',
      minLength: 1,
      errorMessage: {
        minLength: 'Type is required.',
      },
    },
    location: {
      type: 'string',
      minLength: 1,
      errorMessage: {
        minLength: 'Location is required.',
      },
    },
    companyName: {
      type: 'string',
      minLength: 1,
      errorMessage: {
        minLength: 'Company Name is required.',
      },
    },
    legalName: {
      type: 'string',
      minLength: 1,
      errorMessage: {
        minLength: 'Legal Name is required.',
      },
    },
    countryId: {
      type: 'string',
      minLength: 1,
      errorMessage: {
        minLength: 'Country is required.',
      },
    },
  },
  required: [
    'partnerType',
    'location',
    'companyName',
    'legalName',
    'countryId',
  ],
};

export const updateSchema = {
  type: 'object',
  properties: {},
  required: [],
};

export const sortCodeRegexp = /^(\d){2}-(\d){2}-(\d){2}$/;
